import { Component, OnInit, OnDestroy } from '@angular/core';
import { CartItem } from './model/cart-items';
import { CommonModule } from '@angular/common';
import { BcvService } from 'src/app/services/bcv/bcv.service';
import { environment } from 'src/environments/environment.dev';
import { CartService } from 'src/app/services/cart/cart.service';
import { Subscription } from 'rxjs';
import { trigger, state, style, transition, animate } from '@angular/animations';

@Component({
  selector: 'app-cart-items',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './cart-items.component.html',
  styleUrl: './cart-items.component.scss',
  animations: [
    trigger('fadeAnimation', [
      transition(':enter', [
        style({ opacity: 0 }),
        animate('300ms ease-in', style({ opacity: 1 }))
      ]),
      transition(':leave', [
        animate('300ms ease-out', style({ opacity: 0 }))
      ])
    ]),
    trigger('slideAnimation', [
      transition(':enter', [
        style({ transform: 'translateX(100%)' }),
        animate('300ms ease-out', style({ transform: 'translateX(0)' }))
      ]),
      transition(':leave', [
        animate('300ms ease-in', style({ transform: 'translateX(100%)' }))
      ])
    ])
  ]
})
export class CartItemsComponent implements OnInit, OnDestroy {
  loading = false;
  env = environment;
  api: string = '';
  isOpen = false;
  cartItems: CartItem[] = [];
  totalItems: number = 0;
  totalPrice: number = 0;
  bcv: number = 0;
  private subscriptions: Subscription[] = [];


  constructor(private CartServices: CartService, private bcvService: BcvService) {
    this.setRate();
  }
  setRate() {
    this.bcvService.getTasa().subscribe({
      next: (response: any) => {
        if (response && response.rates && response.rates.USD) {
          this.bcv = response.rates.USD;
        } else if (response && response.data && response.data.USD) {
          this.bcv = response.data.USD.price || response.data.USD;
        }
        console.log('Tasa BCV cargada:', this.bcv);
      },
      error: (error) => {
        this.bcvService.handleRequestError(error);
      },
    });
  }


  ngOnInit() {
    this.getCartItems();

    // Suscribirse al estado del carrito
    const cartOpenSub = this.CartServices.cartOpen$.subscribe(isOpen => {
      this.isOpen = isOpen;
      if (isOpen) {
        this.getCartItems();
      }
    });

    // Suscribirse a los cambios en los items
    const itemsSub = this.CartServices.items$.subscribe(items => {
      this.cartItems = items;
      this.calculateTotals();
    });

    this.subscriptions.push(cartOpenSub, itemsSub);
  }

  ngOnDestroy() {
    this.subscriptions.forEach(sub => sub.unsubscribe());
  }

   irAWhatsApp(numero: string, mensaje: string): void {
  const mensajeLimpio = encodeURIComponent(mensaje); 
  const url = `https://wa.me/${numero}?text=${mensajeLimpio}`;
  window.open(url, '_blank');
}

  getCartItems() {
    this.cartItems = this.CartServices.getItems();
    this.calculateTotals();
  }

  calculateTotals() {
    this.totalItems = this.cartItems?.length || 0;
    this.totalPrice = this.cartItems?.reduce((total, item) => {
      const price = item.product?.price || 0;
      const quantity = item.quantity || 1;
      return total + (price * quantity);
    }, 0) || 0;
    
  }

  closeCart() {
    this.CartServices.closeCart();
  }

  // Cerrar al hacer click en el overlay
  onOverlayClick(event: MouseEvent) {
    if (event.target === event.currentTarget) {
      this.closeCart();
    }
  }

  removeItem(index: number) {
    this.cartItems.splice(index, 1);
    // Actualizar localStorage
    localStorage.setItem('cart', JSON.stringify(this.cartItems));
    this.CartServices['itemsSubject'].next(this.cartItems);
    this.calculateTotals();
  }

  updateQuantity(index: number, change: number) {
    const item = this.cartItems[index];
    const newQuantity = item.quantity + change;

    if (newQuantity > 0) {
      item.quantity = newQuantity;
      localStorage.setItem('cart', JSON.stringify(this.cartItems));
      this.CartServices['itemsSubject'].next(this.cartItems);
      this.calculateTotals();
    } else {
      this.removeItem(index);
    }
  }

  clearCart() {
    this.CartServices.clearCart();
    this.calculateTotals();
  }

}
